import React from "react";
import "./AboutUs.scss";

import bill from "../../assets/icons/bill.svg";
import dollar from "../../assets/icons/dollar.svg";
import coin from "../../assets/icons/coin.svg";

const AboutUs = ({exchangeData}) => {
  return (
    <div className="aboutus-container">
      <div>
        <div className="title">معرفی صرافی IEX</div>
        <div className="desc">
          به اطلاع می رساند که فعالیتهای ارزی این صرافی صرفا در چهار چوب قوانین
          بانک مرکزی می باشد این وب سایت صرفا جهت اطلاع رسانی است و هیچ گونه
          خرید و فروشی در آن انجام نمی پذیرد، مشتریان محترم برای انجام خرید و
          فروش به صرافی مراجعه نمایند.
        </div>
      </div>
      <div className="cards-container flex justify-between items-center mt-[4.4rem]">
        <div className="card">
          <img src={bill} alt="" />
          <div>
            <div className="title">خرید و فروش اسکناس</div>
            <div className="desc">
              خرید و فروش انواع اسکناس های رایج دنیا در صرافی آی اکس
            </div>
          </div>
        </div>
        <div className="card">
          <img src={coin} alt="" />
          <div>
            <div className="title">خرید و فروش سکه</div>
            <div className="desc">خرید و فروش انواع سکه و مسکوکات بانکی</div>
          </div>
        </div>
        <div className="card">
          <img src={dollar} alt="" />
          <div>
            <div className="title">خرید ارز</div>
            <div className="desc">خرید ارز حاصل از صادرات به بالاترین نرخ</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
